import type { GlobalErrorProps } from './types';

const ERROR_PATTERNS = {
    SERVER_ERROR_MESSAGES: ['500', 'internal server error', 'server error', 'internal error'],
    SERVER_ERROR_NAMES: ['internalservererror', 'servererror', 'internalerror'],
    NOT_FOUND_MESSAGES: [
        'server components render',
        'digest property',
        'no entry found',
        'category not found',
        'page not found',
    ],
    NOT_FOUND_NAMES: ['notfound'],
} as const;

export function is500Error(error?: GlobalErrorProps['error']): boolean {
    if (!error) return false;

    const errorStatus = error.status;

    // Fast path: check status first (most reliable indicator)
    if (errorStatus === 500) return true;

    const errorName = error.name?.toLowerCase() || '';
    const errorMessage = error.message?.toLowerCase() || '';

    // Check error message patterns
    if (ERROR_PATTERNS.SERVER_ERROR_MESSAGES.some(pattern => errorMessage.includes(pattern))) {
        return true;
    }

    // Check error name patterns
    return ERROR_PATTERNS.SERVER_ERROR_NAMES.some(pattern => errorName.includes(pattern));
}

export function is404(error?: GlobalErrorProps['error']): boolean {
    if (!error) return false;

    // If it's a 500 error, always show generic error page (not 404)
    if (is500Error(error)) return false;

    const errorStatus = error.status;
    const errorName = error.name?.toLowerCase() || '';
    const errorMessage = error.message?.toLowerCase() || '';

    // Fast path: check status first
    if (errorStatus === 404) return true;

    // Check error message patterns
    if (ERROR_PATTERNS.NOT_FOUND_MESSAGES.some(pattern => errorMessage.includes(pattern))) {
        return true;
    }

    // Check error name patterns
    return ERROR_PATTERNS.NOT_FOUND_NAMES.some(pattern => errorName.includes(pattern));
}
